import * as React from 'react';
import { Input, Icon } from '@beehive/components';

export type InputType = 'input' | 'password';

export interface InputPasswordState {
  type: InputType;
}

class InputPassword extends React.Component<any, InputPasswordState> {
  constructor(props: any) {
    super(props);

    this.state = {
      type: 'password',
    };
  }

  toggleInputType = () => {
    const { type } = this.state;
    const newType = type === 'password' ? 'input' : 'password';
    this.setState({ type: newType });
  }

  render() {
    const { type } = this.state;

    return (
      <Input
        {...this.props}
        type={type}
        suffix={
          <Icon
            size="small"
            name={type === 'password' ? 'display-o' : 'hide-o'}
            onClick={this.toggleInputType}
          />
        }
      />
    );
  }
}

export default InputPassword;
